import React from 'react';
import { Monitor, Smartphone } from 'lucide-react';
import { Card } from '@/components/ui/card';

interface MobileNotSupportedOverlayProps {
  isVisible: boolean;
}

export function MobileNotSupportedOverlay({ isVisible }: MobileNotSupportedOverlayProps) {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-[#1E293B] border border-slate-700 rounded-xl p-8 shadow-2xl">
          {/* Icon */}
          <div className="flex justify-center space-x-4 mb-6">
            <div className="relative">
              <Smartphone className="h-16 w-16 text-gray-400"/>
              <div className="absolute -top-1 -right-1 bg-red-500 rounded-full p-1">
                <svg className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </div>
            </div>
            <Monitor className="h-16 w-16 text-blue-400"/>
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-white text-center mb-4">
            Desktop Required
          </h1>

          {/* Description */}
          <div className="space-y-4 text-gray-300 mb-6">
            <p className="text-lg text-center">
              This video chat application requires a desktop or laptop computer for the best experience.
            </p>
            <p className="text-sm text-center text-gray-400">
              Features like video calling, screen sharing, and advanced controls work best on larger screens with full
              keyboard and mouse support.
            </p>
          </div>

          {/* Instructions */}
          <Card className="bg-slate-800/50 border border-slate-600 rounded-lg p-4 space-y-2">
            <h3 className="font-semibold text-white">To access this app:</h3>
            <ul className="text-sm text-gray-300 space-y-1">
              <li>• Use a desktop computer or laptop</li>
              <li>• Open this link in Chrome or Brave</li>
              <li>• Ensure your camera and microphone are available</li>
            </ul>
          </Card>

          {/* Footer */}
          <p className="text-xs text-gray-500 text-center mt-6">
            Thank you for understanding. We're working to bring mobile support in the future.
          </p>
        </div>
      </div>
    </div>
  );
}
